import React from "react";
import * as Rb from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Avatar from "../assets/img/profile.png";
import * as Bi from "react-icons/bs";
import Modal from 'react-bootstrap/Modal';
import "../assets/css/style.css";
class profile extends React.Component
{
    state={
        openModal:false
    }
    onClickButton = e=>{
        e.preventDefault()
        this.setState({openModal : true})
        console.log("test")
    }
    onCloseModal =()=>{
        this.setState({openModal : false})
    }
    render()
    {
        return(
            <div>
                <section className="">
                     <Rb.Container className="">
                        <div className="d-block d-sm-none mb-3 d-grid gap-2"> 
                            <Rb.Button onClick={this.onClickButton} className="btn_align"> Click to View Profile</Rb.Button>
                        </div>
                        <div className="d-none d-sm-block mb-3" id="profile_view">
                        <Rb.Row>
                            <Rb.Col sm={12} md={12} lg={12}>
                            <Rb.Card className="shadow">
                                <Rb.Card.Body>
                                    <div className="avatar_warpper">
                                        {/* <div className="text-center"> */}
                                            <Rb.Card className=" shadow mx-auto inner_card">
                                                <div className="text-center">
                                                    <Rb.Image fluid src={Avatar} alt="image" className="avatar_align" /> 
                                                </div>
                                            </Rb.Card>
                                            <div className="text-center my-4">
                                                <h3 className="sidebar_name">Monisha Thanikachalam</h3>
                                            </div>
                                            <Rb.Card className="destination_align mx-auto shadow my-4">
                                                <div className=" text-center">
                                                    <p className="mb-0 p-1 ">Front-End-Developer</p>
                                                </div>
                                            </Rb.Card>
                                            <div className="my-4 seprator"></div>
                                            <div className="personal_info">
                                                <Rb.ListGroup>
                                                    <Rb.ListGroupItem className="my-2">
                                                        <div className="d-flex">
                                                            <span className="box_1 box shadow text-center">
                                                                <Bi.BsEnvelope className="profile_icon y_color"/>
                                                            </span>
                                                            <div className="ps-2">
                                                                <span className="sb">EMAIL</span><br/>
                                                                <a href="/" className="f-14">monishainfo999@g..</a>
                                                            </div>
                                                        </div>
                                                    </Rb.ListGroupItem>
                                                    <Rb.ListGroupItem className="my-2">
                                                        <div className="d-flex">
                                                            <span className="box_1 box shadow text-center">
                                                                <Bi.BsPhone className="profile_icon y_color"/>
                                                            </span>
                                                            <div className="ps-3">
                                                                <span className="sb">PHONE NO</span><br/>
                                                                <a href="/" className="f-14">+91 9003074612</a>
                                                            </div>
                                                        </div>
                                                    </Rb.ListGroupItem>
                                                    <Rb.ListGroupItem className="my-2">
                                                        <div className="d-flex">
                                                            <span className="box_1 box shadow text-center">
                                                                <Bi.BsCalendarWeek className="profile_icon y_color"/>
                                                            </span>
                                                            <div className="ps-3">
                                                                <span className="sb">DOB</span><br/>
                                                                <a href="/" className="f-14">Sep 09, 1999</a>
                                                            </div>
                                                        </div>
                                                    </Rb.ListGroupItem>
                                                    <Rb.ListGroupItem className="my-2">
                                                        <div className="d-flex">
                                                            <span className="box_1  box shadow text-center">
                                                                <Bi.BsPinMap className="profile_icon y_color"/>
                                                            </span>
                                                            <div className="ps-3">
                                                                <span className="sb">LOCATION</span><br/>
                                                                <a href="/" className="f-14">Chennai-81, TamilNadu</a>
                                                            </div>
                                                        </div>
                                                    </Rb.ListGroupItem>
                                                    
                                                </Rb.ListGroup>
                                            </div>
                                        {/* </div> */}
                                        
                                    </div>
                                </Rb.Card.Body>
                            </Rb.Card>
                            </Rb.Col>
                           
                        </Rb.Row>
                        </div>
                       
                    </Rb.Container>
                </section>
              <section>
              <Rb.Modal show={this.state.openModal} onHide={this.onCloseModal}>
                    <Modal.Body>
                        <div className="" id="profile_view">
                            <Rb.Row>
                                <Rb.Col sm={12} md={12} lg={12}>
                                <Rb.Card className="shadow">
                                    <Rb.Card.Body>
                                        <div className="avatar_warpper">
                                            {/* <div className="text-center"> */}
                                                <Rb.Card className=" shadow mx-auto inner_card">
                                                    <div className="text-center">
                                                        <Rb.Image fluid src={Avatar} alt="image" className="avatar_align" /> 
                                                    </div>
                                                </Rb.Card>
                                                <div className="text-center my-4">
                                                    <h3 className="sidebar_name">Monisha Thanikachalam</h3>
                                                </div>
                                                <Rb.Card className="destination_align mx-auto shadow my-4">
                                                    <div className=" text-center">
                                                        <p className="mb-0 p-1 ">Front-End-Developer</p>
                                                    </div>
                                                </Rb.Card>
                                                <div className="my-4 seprator"></div>
                                                <div className="personal_info">
                                                    <Rb.ListGroup>
                                                        <Rb.ListGroupItem className="my-2">
                                                            <div className="d-flex">
                                                                <span className="box_1 box  text-center">
                                                                    <Bi.BsEnvelope className="profile_icon y_color"/>
                                                                </span>
                                                                <div className="ps-2">
                                                                    <span className="sb">EMAIL</span><br/>
                                                                    <a href="/" className="f-14">monishainfo999@g..</a>
                                                                </div>
                                                            </div>
                                                        </Rb.ListGroupItem>
                                                        <Rb.ListGroupItem className="my-2">
                                                            <div className="d-flex">
                                                                <span className="box_1 box shadow text-center">
                                                                    <Bi.BsPhone className="profile_icon y_color"/>
                                                                </span>
                                                                <div className="ps-3">
                                                                    <span className="sb">PHONE NO</span><br/>
                                                                    <a href="/" className="f-14">+91 9003074612</a>
                                                                </div>
                                                            </div>
                                                        </Rb.ListGroupItem>
                                                        <Rb.ListGroupItem className="my-2">
                                                            <div className="d-flex">
                                                                <span className="box_1 box shadow text-center">
                                                                    <Bi.BsCalendarWeek className="profile_icon y_color"/>
                                                                </span>
                                                                <div className="ps-3">
                                                                    <span className="sb">DOB</span><br/>
                                                                    <a href="/" className="f-14">Sep 09, 1999</a>
                                                                </div>
                                                            </div>
                                                        </Rb.ListGroupItem>
                                                        <Rb.ListGroupItem className="my-2">
                                                            <div className="d-flex">
                                                                <span className="box_1  box shadow text-center">
                                                                    <Bi.BsPinMap className="profile_icon y_color"/>
                                                                </span>
                                                                <div className="ps-3">
                                                                    <span className="sb">LOCATION</span><br/>
                                                                    <a href="/" className="f-14">Chennai-81, TamilNadu</a>
                                                                </div>
                                                            </div>
                                                        </Rb.ListGroupItem>
                                                        
                                                    </Rb.ListGroup>
                                                </div>
                                            {/* </div> */}
                                            
                                        </div>
                                    </Rb.Card.Body>
                                </Rb.Card>
                                </Rb.Col>
                            
                            </Rb.Row>
                        </div>
                    </Modal.Body>
                </Rb.Modal>
              </section>
                
            </div>
        )
    }
}
export default profile
